import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { OpenBase64Pdf, setFocus, exportToExcel, setTitle, ReverseFormatDate, GetDate, formatDate } from "../Common/Common";
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const StockLedger = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const WarehouseName = cookies.get('userName');;
    const WarehouseCode = cookies.get('salesPersonCode');
    const [isLoading, setIsLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [WareHouse, setWareHouse] = useState([])
    const [ItemNo, setItemNo] = useState([])
    const [tableData, setTableData] = useState({})

    const [MenuText, setMenuText] = useState("Stock Ledger");

    const [formData, setformData] = useState({
        Warehouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        ItemNo: '',
        DateFrom: GetDate(-7),
        DateTo: GetDate(0),
        StockLedger: [
        ]
    });
    const [filterData, setfilterData] = useState({
        Warehouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        ItemNo: '',
        DateFrom: GetDate(-7),
        DateTo: GetDate(0),
        StockLedger: [
        ],
        PageIndex: "1",
    });
    const getFromWareHouse = () => {
        setWareHouse([]);
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let Warehouse = res.autoCompleteData || [];
                setWareHouse(Warehouse);
            } else {
                console.error("Error fetching From Ware House data:", res.message);
                setWareHouse([]);
            }
        });
    };
    let WarehouseArr = []
    for (let i = 0; i < WareHouse.length; i++) {
        let mydata = WareHouse[i]?.values
        WarehouseArr.push(mydata)
    };

    const getItemNo = () => {
        setItemNo([]);
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ItemNoData = res.autoCompleteData || [];
                setItemNo(ItemNoData);
            } else {
                console.error("Error fetching Item No:", res.message);
                setItemNo([]);
            }
        });
    };
    let ItemArr = []
    for (let i = 0; i < ItemNo.length; i++) {
        let myItemdata = ItemNo[i]?.values
        ItemArr.push(myItemdata)
    };

    const handleClear = () => {

        setformData({
            ...formData,
            Warehouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
            ItemNo: '',
            DateFrom: GetDate(-7),
            DateTo: GetDate(0),
            StockLedger: []
        });
        setFocus('txtItemNo');
    }
    useEffect(() => {
        setTitle('StockLedger', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    const handleStockLedgerChange = (index, key, value) => {
        const updatedStockLedger = [...formData.StockLedger];
        updatedStockLedger[index][key] = value;

        setformData(prev => ({
            ...prev,
            StockLedger: updatedStockLedger,
        }));
    };

    useEffect(() => {
        setFocus('txtItemNo');
    }, []);

    const GetDataForStockLedger = async (Type, PI = filterData?.PageIndex || "1") => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...formData, Type: Type = null ? "S" : Type, Token, LoginUserCode: loginCodeString,
            
        }
        post(`${API_SERVER}/api/Operation/GetDataForStockLedger`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'E') {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'StockLedger');

                    }
                }
                else {
                    let stockLedger = [];
                    res.Data.forEach((Ledgeritem, index) => {
                        let Ledger = {};
                        Ledger.Date = Ledgeritem.Date;
                        Ledger.InvoiceNo = Ledgeritem.InvoiceNo;
                        Ledger.Remarks = Ledgeritem.Remarks;
                        Ledger.CurrentAvailableItem = Ledgeritem.CurrentAvailableItem;
                        //Ledger.OpeningBalance = Ledgeritem.OpeningBalance !== null ? Ledgeritem.OpeningBalance : '';
                        Ledger.InwardQty = Ledgeritem.InwardQty != null && Ledgeritem.InwardQty !== '' ? Ledgeritem.InwardQty : '';
                        Ledger.OutwardQty = Ledgeritem.OutwardQty != null && Ledgeritem.OutwardQty !== '' ? Ledgeritem.OutwardQty : '';
                        //Ledger.ClosingBalance = Ledgeritem.ClosingBalance != null && Ledgeritem.ClosingBalance !== '' ? Ledgeritem.ClosingBalance : '';
                        Ledger.Description = Ledgeritem.Description != null && Ledgeritem.Description !== '' ? Ledgeritem.Description : '';
                        stockLedger.push(Ledger);
                    })
                    setformData({
                        ...formData,
                        StockLedger: stockLedger
                    });
                    setformData(prevFormData => ({
                        ...prevFormData,
                        Ledger: stockLedger
                    }));
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, res.Focus);
                setTableData({});
                setformData({
                    ...formData,
                    StockLedger: []
                });
            }
            setIsLoading(false)
        })
    }


    const handleDownloadExcel = async () => {
        GetDataForStockLedger('E');
    }

    const handleshow = async () => {
        GetDataForStockLedger('S');
    }
    const handleSubmit = async () => {
        setIsLoading(true)

        const loginCodeString = String(LoginUserCode);
        let data = {
            ...formData,
            Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Operation/InsertStockLedger`, { ...data }, (res) => {

            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                handleClear()
                GetDataForStockLedger('S');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }


    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                label='Item No'
                                                placeholder="Item No"
                                                maxLength='100'
                                                options={ItemArr}
                                                id='txtItemNo'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getItemNo()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtWareHouse") };
                                                }}
                                                inputValue={formData.ItemNo ? formData.ItemNo : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setformData({ ...formData, ItemNo: newInputValue })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                label='WareHouse / Sales Person'
                                                placeholder="WareHouse / Sales Person"
                                                disabled={WarehouseCode ? true : false}
                                                maxLength='100'
                                                options={WarehouseArr}
                                                id='txtWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getFromWareHouse()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtDateFrom") };
                                                }}
                                                inputValue={formData.Warehouse ? formData.Warehouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setformData({ ...formData, Warehouse: newInputValue })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Date</label>
                                            <div class="row">
                                                <div className="col-lg-3 col-md-3 col-sm-3">
                                                    <DatePicker selected={formData.DateFrom}
                                                        id='txtDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setformData({ ...formData, DateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-3">
                                                    <DatePicker selected={formData.DateTo}
                                                        id='txtDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setformData({ ...formData, DateTo: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSearch')
                                                            };
                                                        }}
                                                        minDate={new Date(formData.DateFrom)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={() => GetDataForStockLedger('S')}>
                                                <i className="bi bi-search" /> Search
                                            </button>

                                            <button className="button reset-btn" onClick={handleClear} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}

                                            >
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            {/*<button className="button save-btn" id='btnSave' onClick={handleSubmit} >*/}
                                            {/*    <i className="bi bi-check-lg" /> Save*/}
                                            {/*</button>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <>  {
                formData ? (
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-5">
                        <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr className='light-bg'>
                                            <th>Date</th>
                                            <th>Invoice Number (Customer Name)</th>
                                            {/*<th>Description</th>*/}
                                            {/* <th>OpeningBalance</th>*/}
                                            <th>Inward</th>
                                            <th>Outward</th>
                                            <th>Current Balance</th>
                                            {/*  <th>ClosingBalance</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.StockLedger?.map((Ledger, bodyIndex) => (

                                            <tr className="TableTrhover" key={`row${bodyIndex}`}>
                                                <td>{Ledger.Date}</td>
                                                <td>
                                                    {/* Show remarks only if not blank */}
                                                    {Ledger.Remarks && Ledger.Remarks.trim() !== "" && (
                                                        <div style={{ fontSize: "0.75rem", color: "gray", marginBottom: "2px" }}>
                                                            {Ledger.Remarks}
                                                        </div>
                                                    )}

                                                    {/* Main invoice number */}
                                                    <div style={{ fontWeight: "bold" }}>
                                                        {Ledger.InvoiceNo}
                                                    </div>
                                                </td>
                                                <td> <input
                                                    className="form-control"
                                                    type='text'
                                                    id={`txtInwardQty{bodyIndex}`}
                                                    style={{ minWidth: '20px' }}
                                                    maxLength="10"
                                                    disabled={true}
                                                    value={Ledger.InwardQty || ''}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        const NumInwardQty = inputValue.replace(/[^0-9.]/g, '');
                                                        handleStockLedgerChange(bodyIndex, 'InwardQty', NumInwardQty)
                                                    }}
                                                /></td>
                                                <td> <input
                                                    className="form-control"
                                                    type='text'
                                                    id={`txtOutwardQty{bodyIndex}`}
                                                    style={{ minWidth: '30px' }}
                                                    maxLength="100"
                                                    disabled={true}
                                                    value={Ledger.OutwardQty || ''}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        const NumOutwardQty = inputValue.replace(/[^0-9.]/g, '');
                                                        handleStockLedgerChange(bodyIndex, 'OutwardQty', NumOutwardQty)
                                                    }}
                                                /></td>
                                                <td>{Ledger.CurrentAvailableItem}</td>

                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div >

                ) : (<> </>)
            }
                {/* Loder start*/}

                {/* Loder End*/}
            </>

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default StockLedger